import { createSelector } from "reselect";

import type { AIAgentState } from "app/pages/sales-intelligence/modules/ai-agent/store";
import { selectSalesIntelligenceState } from "app/pages/sales-intelligence/store/selectors";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";

const selectAiAgentState = createStatePropertySelector<AIAgentState>(selectSalesIntelligenceState("aiAgent"));

const selectPdfDownloadState = selectAiAgentState("pdfDownloads");

export const selectActivePdfDownloads = createSelector(
    selectPdfDownloadState,
    ({ activeDownloads }) => activeDownloads,
);

export const selectIsPdfDownloading = createSelector(
    [selectActivePdfDownloads, (_state, messageId: string) => messageId],
    (activeDownloads, messageId) => activeDownloads.includes(messageId),
);

export const selectRedirectModalState = createSelector(selectPdfDownloadState, ({ redirectModal }) => redirectModal);

export const selectIsRedirectModalOpen = createSelector(selectRedirectModalState, ({ isOpen }) => isOpen);

export const selectRedirectModalCompanyName = createSelector(selectRedirectModalState, ({ domain }) => domain);
